import React, { useRef, useState, useEffect } from "react";
import PropTypes from "prop-types";
import { MCard } from "components/Shared";
import Grid from "@mui/material/Grid";
import { getAuditDeterminationResults } from "requests/qaCaseAudit/index.ts";
import { createRequestCoalescer } from "tools/requestCoalescer";

const auditDeterminationCoalescer = createRequestCoalescer();
const activeRequest = { current: true };

const QaCaseAuditWarning = ({
  controlNumber,
}) => {
  const mounted = useRef(true);

  const [isFetchingAuditDetermination, setIsFetchingAuditDetermination] = useState(false);
  const [auditDetermination, setAuditDetermination] = useState({});

  useEffect(() => {
    mounted.current = true;

    setAuditDetermination({});
    setIsFetchingAuditDetermination(true);
    const unsubscribe = auditDeterminationCoalescer.run(
      controlNumber,
      (resolve, reject) => getAuditDeterminationResults(controlNumber, resolve, activeRequest, reject),
      (data) => {
        if (mounted.current) {
          setAuditDetermination(data);
          setIsFetchingAuditDetermination(false);
        }
      },
      () => {
        if (mounted.current) {
          setAuditDetermination({});
          setIsFetchingAuditDetermination(false);
        }
      },
    );

    return () => {
      mounted.current = false;
      unsubscribe();
    };
  }, [controlNumber]);

  const getResultFields = () => {
    let warnings = [{
        label: "Manager Review Required",
        value: "    ",
      }];
    if(auditDetermination.auditRequiredForInspector){
      warnings.push({
        label: "New Inspector",
        value: "    "
      });
    }
    if(auditDetermination.auditRequiredForCustomer){
      warnings.push({
        label: "New Customer",
        value: "    "
      });
    }
    if(auditDetermination.auditRequiredForQaAgent){
      warnings.push({
        label: "New QA Agent",
        value: "    "
      });
    }    
    return warnings;
  }; 

  if(!isFetchingAuditDetermination && !auditDetermination?.auditRequired) {
    return null;
  }

  return (
    <Grid item xs={12}>
      <MCard title={"QA Warning"}
        isFetching={isFetchingAuditDetermination}
        fields={getResultFields()}
      />
    </Grid>    
  );
};

QaCaseAuditWarning.propTypes = {
  controlNumber: PropTypes.number.isRequired,
};

export default QaCaseAuditWarning;